/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Confirm_DoneInputs */

const cs_property_ai_confirm_done = /** @type {(inputs: Property_Ai_Confirm_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Překlad označen jako zkontrolovaný`)
};

const en_property_ai_confirm_done = /** @type {(inputs: Property_Ai_Confirm_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation marked as reviewed`)
};

/**
* | output |
* | --- |
* | "Translation marked as reviewed" |
*
* @param {Property_Ai_Confirm_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_confirm_done = /** @type {((inputs?: Property_Ai_Confirm_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Confirm_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_confirm_done(inputs)
	return cs_property_ai_confirm_done(inputs)
});